import { render, staticRenderFns } from "./IrisSimpleModal.vue?vue&type=template&id=71fa46c3&"
import script from "./IrisSimpleModal.vue?vue&type=script&lang=ts&"
export * from "./IrisSimpleModal.vue?vue&type=script&lang=ts&"
import style0 from "./IrisSimpleModal.vue?vue&type=style&index=0&id=71fa46c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports